// Попап «Get in touch» на нативном <dialog>. Открывают кнопки с
// data-contact-modal-open (href у них ведёт на секцию Contact — запас без JS).
// Закрытие — крестик, Esc, клик по подложке; страница под попапом не
// скроллится; фокус возвращается на открывшую кнопку. Уборка вызывается
// и из close(), и из событий диалога: Esc закрывает <dialog> сам,
// а событие close в некоторых сборках Chrome не приходит — toggle приходит.
export default function ContactModal() {
    const dialog = document.querySelector('[data-contact-modal]');

    if (!dialog || typeof dialog.showModal !== 'function') {
        return;
    }

    const triggers = Array.from(document.querySelectorAll('[data-contact-modal-open]'));
    const closeButton = dialog.querySelector('[data-contact-modal-close]');
    const panel = dialog.querySelector('.contact-modal__panel');

    let opener = null;

    const onClosed = () => {
        document.documentElement.classList.remove('has-modal');

        if (opener) {
            opener.focus();
            opener = null;
        }
    };

    const close = () => {
        dialog.close();
        onClosed();
    };

    const open = (trigger) => {
        opener = trigger;
        dialog.showModal();
        document.documentElement.classList.add('has-modal');

        const firstField = dialog.querySelector('input:not([type="hidden"]), textarea, select');

        (firstField || closeButton).focus();
    };

    triggers.forEach((trigger) => {
        trigger.addEventListener('click', (event) => {
            event.preventDefault();
            open(trigger);
        });
    });

    closeButton.addEventListener('click', close);

    dialog.addEventListener('click', (event) => {
        // Клик по подложке — вне панели — закрывает.
        if (!panel.contains(event.target)) {
            close();
        }
    });

    dialog.addEventListener('close', onClosed);
    dialog.addEventListener('toggle', (event) => {
        if (event.newState === 'closed') {
            onClosed();
        }
    });
}
